// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2qbig","colCheckbox":"styles_colCheckbox__3dSjN"};